import clsx from 'clsx';
import React from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Pagination.module.scss';
import Typography from '../../kit/atoms/Typography/Typography';

interface PaginationProps {
    pageNum: number;
    totalPages: number;
    onPageChange?: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
    pageNum,
    totalPages,
    onPageChange
}) => {
    const st: CssModuleType = currentCssModule;
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
    

    const PAGE_BUFFER = 2;
    let startPage = Math.max(pageNum - PAGE_BUFFER, 1);
    let endPage = Math.min(pageNum + PAGE_BUFFER, totalPages);

    const additionalPages = 5 - (endPage - startPage + 1);


    if (startPage === 1) {
        endPage = Math.min(endPage + additionalPages, totalPages);
    } else if (endPage === totalPages) {
        startPage = Math.max(startPage - additionalPages, 1);
    }

    const visiblePages = pages.filter(
        (page) => page >= startPage && page <= endPage
    );

    return (
        <div className={st.pagination}>
            <button
                aria-label='First'
                className={st['pagination__btn']}
                onClick={() => onPageChange(1)}
                disabled={pageNum === 1}
            >
                <i className='fal fa-angle-double-left'></i>
            </button>
            <button
                aria-label='Previous'
                className={st['pagination__btn']}
                onClick={() => onPageChange(pageNum - 1)}
                disabled={pageNum === 1}
            >
                <i className='fal fa-angle-left'></i>
            </button>

            {visiblePages.map((page) => (
                <button
                    aria-label={page.toString()}
                    className={clsx(
                        st['pagination__page'],
                        page === pageNum ? st['pagination__page--active'] : ''
                    )}
                    key={page}
                    onClick={() => onPageChange(page)}
                    disabled={page === pageNum}
                >
                    <Typography>{page}</Typography>
                </button>
            ))}

            <button
                aria-label='Next'
                className={st['pagination__btn']}
                onClick={() => onPageChange(pageNum + 1)}
                disabled={pageNum === totalPages}
            >
                <i className='fal fa-angle-right'></i>
            </button>
            <button
                aria-label='Last'
                className={st['pagination__btn']}
                onClick={() => onPageChange(totalPages)}
                disabled={pageNum === totalPages}
            >
                <i className='fal fa-angle-double-right'></i>
            </button>
        </div>
    );
};

export default Pagination;
